$(document).ready(function () {
    $(document).on("mouseenter", ".amenu_item", function () {
        $(".amenu_item_title").removeClass('fly');

        $(this).children(".amenu_item_title").addClass('fly');

        $(this).children(".amenu_item_title").css({
            top: $(this)[0].getBoundingClientRect().top + ($(this)[0].getBoundingClientRect().height / 2)
        });
    });

    $(document).on('mouseleave', '.amenu_item', function () {
        $(".amenu_item_title").removeClass('fly');
    });

    $(document).on("click", ".amenu_switcher, .header_panel_switcher, .amenu_bg", function () {
        $(".main-block.amenu_container").toggleClass('active');
    });

    $(document).on("click", ".form_field_eye", function () {
        let id = $(this).attr('id').replace('hide-input-', '');

        if($(`#${id}`).attr('type') == 'text') {
            $(this).children('svg').hide();

            $(this).children('.closed-eye').show();
            $(`#${id}`).attr('type', 'password');
        } else {
            $(this).children('svg').hide();

            $(this).children('.opened-eye').show();
            $(`#${id}`).attr('type', 'text');
        }
    });

    $(document).on("click", ".header_panel_profile_person", function () {
        $(".header_panel_dop_m").removeClass('active');
        $(".header_panel_seasons").removeClass('active');

        $('.header_panel_profile').toggleClass('active');

        return false;
    });

    $(document).on("click", ".header_panel_dop_m_switcher", function () {
        $(".header_panel_profile").removeClass('active');
        $(".header_panel_seasons").removeClass('active');

        $(".header_panel_dop_m").toggleClass('active');

        return false;
    });

    $(document).on("click", ".header_panel_seasons_tit", function () {
        $(".header_panel_profile").removeClass('active');
        $(".header_panel_dop_m").removeClass('active');

        $(".header_panel_seasons").toggleClass('active');

        return false;
    });

    $(document).on("click", ".panel_switcher, .panel_wrapper_bg", function () {
        $(".panel_wrapper").toggleClass('active');
    });

    $(document).on("click", ".select_emul", function () {
        $('.select_emul').not($(this)).removeClass('active');
        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }

        return false;
    });

    $(document).on("click", ".select_emul_list_item", function () {
        if($('.select_emul').attr('class').indexOf('non_removable') === -1) {
            $('.select_emul').removeClass('active');
        }

        return false;
    });

    $(document).on("click", ".pgs", function () {
        $(this).toggleClass('active');

        return false;
    });

    $(document).on("click", ".t_filter_switcher", function () {
        $('.t_filter_box_wrapper').toggleClass('active');

        return false;
    });

    $(document).click(function (event) {
        $('.select_emul').removeClass('active');
        $(".header_panel_dop_m").removeClass('active');
        $(".header_panel_seasons").removeClass('active');
        $(".header_panel_profile").removeClass('active');
        $(".pgs").removeClass('active');
        $(".cabinet-menu-dropdown").removeClass('active');
        if($(event.target).attr("class") !== 'dropdown-search'){
            $(".cabinet-company-dropdown").removeClass('active');
        }
    });

    $(document).on("click", ".t_filter_box_wrapper_bg, .t_filter_box_wrapper .form_item_button", function () {
        $('.t_filter_box_wrapper').removeClass('active');
    });

    $(document).scroll(function() {
        if ($(window).width() > 1100) {
            if(window.pageYOffset > 122) {
                $(".header-main").addClass('fixed');
            } else {
                $(".header-main").removeClass('fixed');
            }
        }
    });

    $(document).on('mouseenter', '[data-toggle="tooltip"]', function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });

    $(document).on("click", ".wallet-table .t_row_info", function () {
        $(this).closest('.t_row').toggleClass('active');
    });

    $(document).on("click", ".order-toggler_check label", function (e) {
        e.preventDefault();
        let togglerType = $(this).closest('.order-toggler_check').attr('data-type');
        let togglerId = $(this).closest('.order-toggler_check').find('input').attr('id');

        $('#popup-confirmation').removeClass('hidden').addClass('active');
        $('#popup-confirmation .popup').attr('data-target', togglerId);
        if(togglerType === 'sentCheck'){
            $('#popup-confirmation .sent').removeClass('hidden');
            $('#popup-confirmation .received').addClass('hidden');
        }else{
            $('#popup-confirmation .sent').addClass('hidden');
            $('#popup-confirmation .received').removeClass('hidden');
        }
    });

    $(document).on("click", "#popup-confirmation .close-event", function () {
        $('#popup-confirmation').removeClass('active').addClass('hidden');
        $('#popup-confirmation .popup').attr('data-target', '');
        $('#popup-confirmation .file-js-uploader input[type="file"]').val(null).trigger('change');
    });

    $(document).on("click", "#popup-confirmation .submit-event", function () {
        let targetId = $('#popup-confirmation .popup').attr('data-target');
        $('#'+targetId).prop("checked", true);
        $('#'+targetId).closest('.order-toggler').addClass('disabled');
        $('#popup-confirmation').removeClass('active').addClass('hidden');
        $('#popup-confirmation .popup').attr('data-target', '');
        $('#popup-confirmation .file-js-uploader input[type="file"]').val(null).trigger('change');
    });

    $(document).on("change", ".file-js-uploader input[type='file']", function () {
        let file = this.files;
        if (file && file[0]) {
            $(this).closest('.file-js-uploader').find('.uploaded-name').text(file[0].name);
            $(this).closest('.file-js-uploader').addClass('uploaded');
        }else{
            $(this).closest('.file-js-uploader').removeClass('uploaded');
        }
    });
    $('.file-js-uploader').bind('dragover', function(event){
        event.preventDefault();
        if (!event.currentTarget.classList.contains('active-drag')) {
            event.currentTarget.classList.add('active-drag');
        }
    });
    $('.file-js-uploader').bind('dragleave', function(event){
        event.preventDefault();
        event.currentTarget.classList.remove('active-drag');
    });
    $('.file-js-uploader').bind('drop', function(event){
        event.preventDefault();
        this.querySelector("input[type='file']").files = event.originalEvent.dataTransfer.files;
        $('#popup-confirmation .file-js-uploader input[type="file"]').trigger('change');
        event.currentTarget.classList.remove('active-drag');
    });

    $(document).on("change", ".promo-container_culture input[type='checkbox']", function () {
        let culturesStatus = $(".promo-container_culture input:checked").length;
        if(culturesStatus >= 1){
            $('.promo-container_nav_stage span').text('33%');
            $('.promo-container_nav_line div').removeClass('hidden');
            $('.promo-container_nav_btns a').removeClass('disabled');
        }else{
            $('.promo-container_nav_stage span').text('0%');
            $('.promo-container_nav_line div').addClass('hidden');
            $('.promo-container_nav_btns a').addClass('disabled');
        }
    });

    $(document).on("click", "#popup-promo .close-event", function () {
        $('#popup-promo').removeClass('active').addClass('hidden');
    });
    $(document).on("click", "#popup-promo .slide-one", function () {
        $('#popup-promo .slide-one').addClass('hidden');
        $('#popup-promo .slide-two').removeClass('hidden');
    });
    $(document).on("click", "#popup-promo .slide-two", function () {
        $('#popup-promo .slide-two').addClass('hidden');
        $('#popup-promo .slide-three').removeClass('hidden');
    });

    $(document).on("click", ".add-area_table_item .toggler", function () {
        $(this).closest('.add-area_table_item').toggleClass('active');
    });

    $(document).on("click", ".main-products_tab .main-products_tab_name", function () {
        $('.main-products_tab').removeClass('active');
        $(this).closest('.main-products_tab').addClass('active');
    });

    $(document).on("click", "#scrollupBtn", function () {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    $(document).on("click", ".section-accordion .cabinet-section_top", function () {
        $(this).closest('.section-accordion').toggleClass('closed');
    });

    $(document).on("click", ".popup-close", function () {
        $(this).closest('.cabinet-popup-container').removeClass('active');
    });

    $(document).on("click", ".cabinet-company-dropdown .toggler", function () {
        $(this).closest('.cabinet-company-dropdown').addClass('active');
        return false;
    });

    $(document).on("click", ".cabinet-menu-dropdown .toggler", function () {
        $(this).closest('.cabinet-menu-dropdown').addClass('active');
        return false;
    });

    $(document).on("click", "#popup-approval-default .add-coment-btn", function () {
        $(this).closest('#popup-approval-default').addClass('hidden');
        $("#popup-approval-add").removeClass('hidden');
    });

    $(document).on("click", ".popup-btn", function () {
        $('.cabinet-popup-container').removeClass('active');
        $($(this).attr('popup-target')).addClass('active');
    });

    $(document).on("click", ".cabinet-header_toggler", function () {
        $('.cabinet-sidebar').addClass('active');
    });

    $(document).on("click", ".cabinet-sidebar_top .toggler", function () {
        $('.cabinet-sidebar').removeClass('active');
    });

    const uploadContainer = document.getElementById('uploadContainer');
    const fileInput = document.getElementById('fileInput');
    const fileInfo = document.getElementById('fileInfo');
    if(uploadContainer){
        uploadContainer.addEventListener('dragover', (event) => {
            event.preventDefault();
            uploadContainer.classList.add('dragover');
        });

        uploadContainer.addEventListener('dragleave', () => {
            uploadContainer.classList.remove('dragover');
        });

        uploadContainer.addEventListener('drop', (event) => {
            event.preventDefault();
            uploadContainer.classList.remove('dragover');

            const files = event.dataTransfer.files;
            if (files.length) {
                handleFileUpload(files[0]);
                let fileInput = uploadContainer.querySelector('input[type="file"]');
                fileInput.files = files;
            }
        });

        fileInput.addEventListener('change', function(event) {
            const file = event.target.files[0];
            if (file) {
                handleFileUpload(file);
            }
        });

        function handleFileUpload(file) {
            document.querySelector('.upload-file .file-name').textContent = file.name;
            document.querySelector('.upload-file .file-size').textContent = `${(file.size / 1024).toFixed(2)} KB`;
            fileInfo.classList.remove('hidden');
        }

        document.getElementById('deleteFile').addEventListener('click', function() {
            fileInput.value = '';
            fileInfo.classList.add('hidden');
        });
    }

    /** example test **/
    $(document).on("click", "#cancel-worksheet-btn", function () {
        $('#cancel-worksheet-popup').removeClass('active');
        $('#cancel-worksheet-success-popup').addClass('active');
     });

});
